import { render, staticRenderFns } from "./BlendsImportHistory.vue?vue&type=template&id=cd52e418"
import script from "./BlendsImportHistory.vue?vue&type=script&lang=js"
export * from "./BlendsImportHistory.vue?vue&type=script&lang=js"
import style0 from "./BlendsImportHistory.vue?vue&type=style&index=0&id=cd52e418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports